import { Person } from "@microsoft/mgt-react";
import { Suspense } from "react";

const CustomLine1 = (props) => {
  const { person } = props.dataContext;
  return (
    <div>
      <div>{person.displayName}</div>
    </div>
  );
};

const CustomLine2 = (props) => {
  return (
    <div>
      <div>{props.line2Property}</div>
    </div>
  );
};

export const PersonWithSuspense = ({
  email,
  line2Property,
  view = "oneline",
  person,
  avatarType = "photo",
}) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Person
        personDetails={person}
        personQuery={email}
        view={view}
        personCard="click"
        avatarType={avatarType}
      >
        <CustomLine1 template={"line1"} />
        <CustomLine2
          template={"line2"}
          line2Property={line2Property}
        />
      </Person>
    </Suspense>
  );
};

export default PersonWithSuspense;
